import React from 'react';

import config from "../config/config";

import IFrame from '../components/iframe';

const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/Basket2.aspx?resize=true`;

export default function IframeBasket() {

    return (
        <div className='booking-pathway__container booking-pathway__iframe-basket'>
            
            <div className='booking-pathway__main-content flex'>
                <h1 className='sr-only'>Basket</h1>

                <IFrame url={iframeURL} title="Basket" hasLoader="true" />

            </div>
        </div>
    );
}